<script setup>
import Button from './button/Button.vue';
defineProps({
  title: {
    type: String,
    required: true,
  },
  buttons: {
    type: Array,
    default: () => [],
  },
  showChevron: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['click', 'close']);

const handleButtonClick = button => {
  emit('click', button.key);
};
</script>

<template>
  <div
    class="flex items-center justify-between px-4 py-2 h-[3.25rem] bg-n-background dark:bg-n-black"
  >
    <div class="flex items-center justify-between gap-2 flex-1">
      <div class="flex items-center gap-1 cursor-pointer select-none">
        <span class="font-medium text-sm text-n-slate-12">{{ title }}</span>
        <span v-if="showChevron" class="i-lucide-chevron-down size-3 text-n-slate-11 mt-0.5" />
      </div>
      <div class="flex items-center">
        <Button
          v-for="button in buttons"
          :key="button.key"
          v-tooltip="button.tooltip"
          :icon="button.icon"
          ghost
          sm
          @click="handleButtonClick(button)"
        />
        <Button
          v-tooltip="$t('GENERAL.CLOSE')"
          icon="i-lucide-x"
          ghost
          sm
          @click="$emit('close')"
        />
      </div>
    </div>
  </div>
</template>
